export default "__VITE_ASSET__spO0DSPl__"